import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'

import Product from './Product/Product'
import EmojiSlider from "../category/Content/EmojiSlider"
import { useEffect, useRef } from 'preact/hooks';

export default () => {
    const { response: { products }, loading, pageType } = useAppState();
    const gridRef = useRef(null);
    const isPLP = pageType === "category";

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => {
                api.loadRecommendations({ skipPageViews: true, skipEvents: true })
            })
        }

        return () => {
            if(!window.Nosto?.disruptorsLoading && gridRef.current) {
                window.Nosto.disruptorsLoading = true;
                gridRef.current.querySelectorAll('.ns-hidden').forEach(el => {
                    el.classList.remove('ns-hidden');
                })
                window.Nosto.disruptorsLoading = false;
            }
        }
    }, [products, gridRef])

    useEffect(() => {
        let timeoutId;
    
        function checkMarkets() {
            if (typeof Nosto.migrateToShopifyMarket === "function") {
                Nosto.migrateToShopifyMarket({
                    productSectionElement: '.ns-serp .nosto-item',
                    productUrlElement: '.ns-serp .nosto-product-url',
                    productHandleAttribute: 'nosto-handle',
                    priceElement: '.ns-serp .nosto-price',
                    listPriceElement: '.ns-serp .nosto-listprice',
                }).then(res => {
                    document.querySelectorAll('.ns-serp .nosto-item').forEach(prodEl => {
                        prodEl.classList.remove('nosto-item')
                    })
                })
            } else {
                timeoutId = setTimeout(checkMarkets, 1000);
            }
        }
    
        checkMarkets();
    
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [ products.hits ]);

    return (
        <div
            aria-live="polite"
            role="log"
            class="ns-product-list product-list--image-shape-portrait-45"
            // class="ns-product-list product-list--per-row-3 product-list--per-row-mob-2 product-list--per-row-mob-2 product-list--image-shape-portrait-45"
            style={loading ? 'opacity: 0.3;' : ''}
            ref={gridRef}
        >
            {products.hits.map((hit, index) => (
                (!isPLP || isPLP && index !== 11) 
                    ?   <Product product={hit} key={hit.productId || index} />
                    :   <>
                            <Product product={hit} key={hit.productId || index} />
                            <EmojiSlider />
                        </>
            ))}

            {/* {isPLP && products.total > 12 ? (
                <>
                    {products.hits.filter((hit, index) => index < 12).map((hit, index) => {
                        return <Product product={hit} key={hit.productId || index} />
                    })}
                    <EmojiSlider />
                    {products.hits.filter((hit, index) => index > 12).map((hit, index) => {
                        return <Product product={hit} key={hit.productId || index} />
                    })}
                </>
            ) : (
                <>
                {products.hits.map((hit, index) => {
                    return <Product product={hit} key={hit.productId || index} />
                })}
                </>
            )} */}
        </div>
    )
}
